import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IColuna } from "app/types/IColuna";
import { resetAll } from "./actions/resetAll";

// Estado inicial constante (não recriado)
const INITIAL_STATE: IColuna[] = [];

const colunasGridOrcamentoSlice = createSlice({
    name: "colunasGridOrcamento",
    initialState: INITIAL_STATE,
    extraReducers: builder => builder.addCase(resetAll, () => INITIAL_STATE),
    reducers: {
        atualizar: (state, action: PayloadAction<IColuna[]>) => {
            // Otimização: só atualiza se a referência for diferente
            if (action.payload !== state) {
                return action.payload;
            }
            return state; // Mantém estado atual se igual
        }
    }
});

export default colunasGridOrcamentoSlice.reducer

export const {
    atualizar
} = colunasGridOrcamentoSlice.actions